import PropTypes from 'prop-types';
import React from 'react';
import { ButtonGroup, Button } from 'react-bootstrap';


const NextPrevButtonToolbar = ({ backtext, nextText, activeBackButton, activeNextButton, onClickBack, onClickNext }) => {
    const enabledbuttonStyle = { backgroundColor: '#60A917', color: 'white', borderRadius: 0 };
    const disabledbuttonStyle = { backgroundColor: 'white', color: 'black', borderRadius: 0 };


    var backStyle = enabledbuttonStyle;
    var nextStyle = enabledbuttonStyle;

    if (!activeBackButton) {
        activeBackButton = false;
        backStyle = disabledbuttonStyle;
    }
    if (!activeNextButton) {
        activeNextButton = false;
        nextStyle = disabledbuttonStyle;
    }

    return (
        <ButtonGroup justified>
            <Button disabled={!activeBackButton} href="#" style={backStyle} onClick={onClickBack}><span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> {backtext}</Button>
            <Button disabled={!activeNextButton} href="#" style={nextStyle} onClick={onClickNext}>{nextText} <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></Button>
        </ButtonGroup>
    );
};

NextPrevButtonToolbar.propTypes = {
    activeBackButton: PropTypes.bool,
    activeNextButton: PropTypes.bool,
    onClickBack: PropTypes.func,
    onClickNext: PropTypes.func
};

export default NextPrevButtonToolbar;
